module.exports = __webpack_public_path__ + "img/背景拷贝4.b8bf9b00.png";